// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-dialog-filter__filter-select {
  display: flex;
  height: 100%;
  overflow: hidden;
}
.dl-dialog-filter__select-column {
  position: relative;
  height: 100%;
}
.dl-dialog-filter__select-column_left {
  width: calc(50% + 1px);
  border-right: 1px solid var(--g-color-line-generic);
}
.dl-dialog-filter__select-column_right {
  width: calc(50% - 1px);
}
.dl-dialog-filter__select-column_disabled::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--g-color-base-float);
  opacity: 0.5;
}
.dl-dialog-filter__select-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 10px 30px;
  font-size: var(--g-text-body-2-font-size);
  line-height: var(--g-text-body-2-line-height);
}
.dl-dialog-filter__select-column-items {
  display: flex;
  height: calc(100% - 48px);
}
.dl-dialog-filter__select-column-items .g-list .g-list__filter {
  margin: 0 30px 10px;
}
.dl-dialog-filter__select-column-items_disabled .g-list__items::after {
  content: "";
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: var(--g-color-base-float);
  opacity: 1;
}
.dl-dialog-filter__select-column-item {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-left: 32px;
  cursor: pointer;
}
.dl-dialog-filter__select-column-item:hover .dl-dialog-filter__select-column-item-description {
  display: block;
}
.dl-dialog-filter__select-column-item-label {
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dl-dialog-filter__select-column-item-label_empty {
  font-style: italic;
  opacity: 0.5;
}
.dl-dialog-filter__select-column-item-description {
  display: none;
  flex: 0 0 110px;
  text-align: center;
  color: var(--g-color-text-secondary);
}
.dl-dialog-filter__select-column-loader {
  position: absolute;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100% - 86px);
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/DialogFilter/SelectFilter/SelectFilter.scss"],"names":[],"mappings":"AAcI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;AAbR;AAgBI;EACI,kBAAA;EACA,YAAA;AAdR;AAgBQ;EACI,sBAAA;EACA,mDAAA;AAdZ;AAiBQ;EACI,sBAAA;AAfZ;AAkBQ;EA9BJ,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2CAAA;EACA,YAwBsB;AAT1B;AAaI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,yCAAA;EACA,6CAAA;AAXR;AAcI;EACI,aAAA;EACA,yBAAA;AAZR;AAcQ;EACI,mBAAA;AAZZ;AAeQ;EApDJ,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,2CAAA;EACA,UA8CsB;AAN1B;AAUI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AARR;AAUQ;EACI,cAAA;AARZ;AAYI;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAVR;AAYQ;EACI,kBAAA;EACA,YAAA;AAVZ;AAcI;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,oCAAA;AAZR;AAeI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;AAbR","sourcesContent":[".dl-dialog-filter__filter-select {\n  display: flex;\n  height: 100%;\n  overflow: hidden;\n}\n.dl-dialog-filter__select-column {\n  position: relative;\n  height: 100%;\n}\n.dl-dialog-filter__select-column_left {\n  width: calc(50% + 1px);\n  border-right: 1px solid var(--g-color-line-generic);\n}\n.dl-dialog-filter__select-column_right {\n  width: calc(50% - 1px);\n}\n.dl-dialog-filter__select-column_disabled::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: var(--g-color-base-float);\n  opacity: 0.5;\n}\n.dl-dialog-filter__select-column-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 10px 30px;\n  font-size: var(--g-text-body-2-font-size);\n  line-height: var(--g-text-body-2-line-height);\n}\n.dl-dialog-filter__select-column-items {\n  display: flex;\n  height: calc(100% - 48px);\n}\n.dl-dialog-filter__select-column-items .g-list .g-list__filter {\n  margin: 0 30px 10px;\n}\n.dl-dialog-filter__select-column-items_disabled .g-list__items::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: var(--g-color-base-float);\n  opacity: 1;\n}\n.dl-dialog-filter__select-column-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding-left: 32px;\n  cursor: pointer;\n}\n.dl-dialog-filter__select-column-item:hover .dl-dialog-filter__select-column-item-description {\n  display: block;\n}\n.dl-dialog-filter__select-column-item-label {\n  flex: 1 1 auto;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.dl-dialog-filter__select-column-item-label_empty {\n  font-style: italic;\n  opacity: 0.5;\n}\n.dl-dialog-filter__select-column-item-description {\n  display: none;\n  flex: 0 0 110px;\n  text-align: center;\n  color: var(--g-color-text-secondary);\n}\n.dl-dialog-filter__select-column-loader {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: calc(100% - 86px);\n  z-index: 1;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
